import { Injectable, Output, EventEmitter, NgModule, defineInjectable } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class NetworkStatusAngularService {
    constructor() {
        this.status = new EventEmitter();
        this.bind();
        window.addEventListener('online', this.updateOnlineStatus);
        window.addEventListener('offline', this.updateOfflineStatus);
    }
    /**
     * @return {?}
     */
    bind() {
        this.updateOnlineStatus = this.updateOnlineStatus.bind(this);
        this.updateOfflineStatus = this.updateOfflineStatus.bind(this);
    }
    /**
     * @return {?}
     */
    updateOnlineStatus() {
        this.status.next(true);
    }
    /**
     * @return {?}
     */
    updateOfflineStatus() {
        this.status.next(false);
    }
}
NetworkStatusAngularService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
NetworkStatusAngularService.ctorParameters = () => [];
NetworkStatusAngularService.propDecorators = {
    status: [{ type: Output }]
};
/** @nocollapse */ NetworkStatusAngularService.ngInjectableDef = defineInjectable({ factory: function NetworkStatusAngularService_Factory() { return new NetworkStatusAngularService(); }, token: NetworkStatusAngularService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class NetworkStatusAngularModule {
    /**
     * @return {?}
     */
    static forRoot() {
        return {
            ngModule: NetworkStatusAngularModule,
            providers: [NetworkStatusAngularService]
        };
    }
}
NetworkStatusAngularModule.decorators = [
    { type: NgModule, args: [{
                imports: [],
                declarations: []
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

export { NetworkStatusAngularService, NetworkStatusAngularModule };

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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